const localization = {
  nl: {
    title: "Het huis",
    featuresTitle: "Kenmerken en faciliteiten",
    featuresP1:
      "Het huis is erg praktisch ingericht. Zo zijn er 9 slaapkamers met op iedere slaapkamer een douche, wastafel en toilet. Twee van deze slaapkamers bevinden zich op de begane grond, en zijn geschikt voor minder-validen (geen drempels). Op de begane grond bevinden zich verder de gemeenschapsruimte, de keuken, extra toiletten en een droogruimte.",
    featuresP2:
      "Op de eerste etage bevinden zich de overige 7 slaapkamers (waarvan 1 kamer is ingericht voor 4 personen en 1 kamer voor 6 personen). De tweede etage is multifunctioneel ingericht als speel -, oefen- of knutselruimte. Mocht het slecht weer zijn, er is een fraaie zolder waar allerlei activiteiten gedaan kunnen worden.Ook leuk voor een spelletjesavond.",
    featuresSlider1Alt: "Slaapkamer",
    featuresSlider2Alt: "Badkamer",
    featuresSlider3Alt: "Recreatieruimte",
    featuresSlider4Alt: "Hal",
    featuresSlider5Alt: "Keuken",
    featuresSlider6Alt: "Woonkamer",
    featuresItems1Title: "Algemeen",
    featuresItems1: [
      "Voldoende parkeerplaatsen",
      "Terras met veranda",
      "Grote tuin",
      "Internet en WiFi",
      "Geheel rookvrij"
    ],
    featuresItems2Title: "Recreatie",
    featuresItems2: [
      "Tafeltennis",
      "Tafelvoetbal",
      "Airhockey",
      "Trampoline",
      "Bordspellen",
      "Recreatieruimte",
      "Wandelroutes",
      "Fietsroutes",
      "Mountainbikeroutes"
    ],
    featuresItems3Title: "Huishoudelijk",
    featuresItems3: [
      "Vaatwasser",
      "Kookgelegenheid",
      "Magnetron",
      "Koelkast",
      "Koffiezetapparaat",
      "Exclusief beddengoed",
      "Exclusief handdoeken",
      "Exclusief theedoeken"
    ],
    featuresItems4Title: "Inrichting",
    featuresItems4: [
      "Douche, toilet en wastafel per slaapkamer",
      "2 Slaapkamers begane grond",
      "7 Slaapkamers eerste etage",
      "Grote speelruimte tweede etage",
      "Kinderbed beschikbaar",
      "Kinderstoel",
      "Droogruimte",
      "Barbecue"
    ],
    historyTitle: "Geschiedenis",
    historyP1:
      "Het huis “Ferienhaus Vulkaneifel Kopp” is in 1983-1984 gebouwd als pension. In 1989 werd het pension overgenomen door een wandelvereniging uit Köln. Sinds 1993 is het huis (onder de naam “Wanderheim Vulkaneifel”) in bezit geweest van de “Mährisch-Schlesischer-Sudetengebirgsverein”. Het huis was tegen een vergoeding toegankelijk voor alle leden (en eventuele gasten) van de MSSGV.",
    historyP2:
      "Sinds 2016 is het huis in het bezit van Toine en Anja Spierings. Zij hebben het concept iets veranderd en het huis ingezet als groepswoning. Het huis kan dus sinds 2016 gehuurd worden door grotere groepen en grote families (tot 24 personen), maar is niet meer voor individuen toegankelijk.",
    koppTitle: "Kopp",
    koppP1:
      "Het plaatsje Kopp is met zijn ca. 200 inwoners een klein rustig dorpje dat is omgeven door romatische dalen in het hart van de Vulkaan-Eifel. De gemeente is ongeveer 840 hectare groot en kent een hoogte van 404 tot 559 meter.",
    koppP2:
      "Kopp kent lokale clubs en ambachtelijke bedrijven. De plaats is idyllisch omgeven door loof- en naaldbossen, kent vele vakantiewoningen en een hotel. Op de vele goed bewegwijzerde wandelpaden is het niet ongewoon dat u tijdens het lopen wild tegenkomt.",
    koppP3:
      "Bij Kopp hoort ook het gehucht Eigelbach, dat gelegen is in een drooggevallen kratermeer. Dit is zeer goed te zien als u van Gerolstein, via Hinterhausen naar Kopp rijdt. Eigelbach ligt iets ten noorden van Kopp."
  },
  de: {
    title: "Das Haus",
    featuresTitle: "Funktionen und Einrichtungen",
    featuresP1:
      "Das Haus hat eine sehr praktische Dekoration. Es gibt 9 Schlafzimmer mit Dusche, Waschbecken und Toilette. Zwei dieser Schlafzimmer sind rollstuhlgerecht (keine erhöhten Türstufen). Es gibt auch ein Wohnzimmer, eine Küche, zusätzliche Toiletten und einen Trockenraum.",
    featuresP2:
      "Auf der ersten Etage sind weitere 7 Schlafzimmer (ein Zimmer für 4 und ein Zimmer für 6 Personen). Der zweite Stock ist multifunktional und hat ein Spiel-, eine Übung- und ein Handwerkzimmer. Bei schlechtem Wetter gibt es einen schönen und großen Dachboden, wo alle Arten von Spielen gespielt werden können.",
    featuresSlider1Alt: "Slafzimmer",
    featuresSlider2Alt: "Badezimmer",
    featuresSlider3Alt: "Aufenthalstraum",
    featuresSlider4Alt: "Eingangshalle",
    featuresSlider5Alt: "Küche",
    featuresSlider6Alt: "Wohnzimmer",
    featuresItems1Title: "Allgemein",
    featuresItems1: [
      "Ausreichend Parkplätze",
      "Terrasse mit Veranda",
      "Großer Garten",
      "Internet und WLAN/WiFi",
      "Vollständig Nichtraucher"
    ],
    featuresItems2Title: "Erholung",
    featuresItems2: [
      "Ping-Pong-Tisch",
      "Tischfußball",
      "Airhockeytisch",
      "Trampolin",
      "Brettspiele",
      "Aufenthalstraum",
      "Wanderwege",
      "Fahrradwege",
      "Mountainbike-Strecken"
    ],
    featuresItems3Title: "Haushalt",
    featuresItems3: [
      "Geschirrspüler",
      "Kochmöglichkeiten",
      "Mikrowelle",
      "Kühlschrank",
      "Kaffeemaschine",
      "Ausgeschlossen: Bettwäsche",
      "Ausgeschlossen: Handtücher",
      "Ausgeschlossen: Küchentücher"
    ],
    featuresItems4Title: "Einrichtungen",
    featuresItems4: [
      "Badezimmer mit Dusche, Toilette und Waschbecken pro Zimmer",
      "2 Schlafzimmer im Erdgeschoss",
      "7 Schlafzimmer im ersten Stock",
      "Großer Spielzimmer im zweiten Stock",
      "Kinderbett zur Verfüging",
      "Kinderstuhl verfügbar",
      "Trockenraum",
      "Barbecue"
    ],
    historyTitle: "Geschichte",
    historyP1:
      "Das “Ferienhaus Vulkaneifel Kopp” wurde in 1983-1984 als Gasthaus gebaut. Im Jahr 1989 wurde das Gasthaus durch ein Wanderverein in Köln übernommen. Seit 1993 war das Haus (unter dem Namen “Wanderheim Vulkaneifel”) im Besitz der “Mährisch-Schlesischer-Sudetengebirgsverein”. Das Haus wurde für eine Gebühr offen für alle Mitglieder (und Ihren Gäste) des MSSGV.",
    historyP2:
      "Seit 2016 ist das Haus im Besitz von Toine und Anja Spierings. Sie haben das Konzept ein wenig geändert und das Haus als Wohngruppe verwendet. Das Haus kann ab 2016 gemietet werden von größeren Gruppen und großen Familien (bis zu 24 Personen), aber es ist nicht mehr zugänglich für Einzelpersonen.",
    koppTitle: "Kopp",
    koppP1:
      "Die Stadt Kopp, ist ein kleines ruhiges Dorf mit rund 200 Einwohnern. Das Dorf ist umgeben von romantischen Tälern im Herzen des Vulkaneifels. Kopp ist etwa 840 Hektar groß und liegt auf eine Höhe von 404 bis 559 Metern.",
    koppP2:
      "Kopp hat lokale Vereine und Handwerksbetriebe. Der Ort ist idyllisch, von Laub- und Nadelwäldern umgeben, hat viele Ferienhäuser und ein Hotel. Auf den vielen gut ausgeschilderten Wanderwegen, ist es nicht ungewöhnlich, dass Sie auf Wildtiere stoßen beim Spaziergang.",
    koppP3:
      "Bei Kopp gehört auch den Weiler Eigelbach, die Sich in einem trockenen Kratersee befindet. Sehr gut zu sehen wenn Sie von Gerolstein über Hinterhausen nach Kopp fahren. Eigelbach liegt unmittelbar nördlich von Kopp."
  },
  en: {
    title: "The house",
    featuresTitle: "Features and facilities",
    featuresP1:
      "The house has a very practical decoration. There are 9 bedrooms with each a shower, sink, and toilet. Two of these bedrooms are on the ground floor and are wheelchair accessible (no elevated doorsteps). There is also a living room, a kitchen, additional toilets and a drying room.",
    featuresP2:
      "On the first floor are another 7 bedrooms (one room for 4, and one room for 6 people). The second floor is multifunctional and has as a play, an exercise and a craftroom. In case of bad weather, there is a beautiful and large attic where all kinds of games can be played.",
    featuresSlider1Alt: "Bedroom",
    featuresSlider2Alt: "Bathroom",
    featuresSlider3Alt: "Recreation room",
    featuresSlider4Alt: "Hallway",
    featuresSlider5Alt: "Kitchen",
    featuresSlider6Alt: "Living room",
    featuresItems1Title: "General",
    featuresItems1: [
      "Ample parking",
      "Terrace with veranda",
      "Large garden",
      "Internet and WiFi",
      "Non-smoking"
    ],
    featuresItems2Title: "Recreation",
    featuresItems2: [
      "Ping-Pong table",
      "Foosball table",
      "Airhockey table",
      "Trampoline",
      "Board games",
      "Recreation room",
      "Hiking trail",
      "Bicycle trails",
      "Mountainbike trails"
    ],
    featuresItems3Title: "Domestic",
    featuresItems3: [
      "Dishwasher",
      "Cooking facilities",
      "Microwave",
      "Refrigerator",
      "Coffeemaker",
      "Excluded: Bedding",
      "Excluded: Towels",
      "Excluded: Kitchen towels"
    ],
    featuresItems4Title: "Facilities",
    featuresItems4: [
      "Bathroom with shower, toilet and sink per room",
      "2 Bedrooms on ground floor",
      "7 Bedrooms on first floor",
      "Large play area on second floor",
      "Cot available",
      "Children's chair available",
      "Drying room",
      "Barbecue"
    ],
    historyTitle: "History",
    historyP1:
      'The house "Ferienhaus Vulkaneifel Kopp" was built as a guest house in 1983-1984. In 1989 the guest house was taken over by a hiking club from Köln. The house had been in posession of the "Mährisch-Schlesischer-Sudetengebirgsverein" under the name "Wanderheim Vulkaneifel" (MSSGV) since 1993. The house was accessible to all members (and any guests) of the MSSGV for a fee.',
    historyP2:
      "Since 2016 the house is owned by Toine and Anja Spierings. They have changed the concept slightly and have repurposed the house as a group home. The house can now be rented by larger groups and large families (up to 24 people), but is no longer accessible to individuals.",
    koppTitle: "Kopp",
    koppP1:
      "The town of Kopp, with its 200 inhabitants, is a small quiet village surrounded by romantic valleys in the heart of the Vulkaneifel. The municipality is about 840 hectares and has an altitude of 404 to 559 meters.",
    koppP2:
      "Kopp has local clubs and craft companies. The place is idyllically surrounded by deciduous and coniferous forests, has many holiday homes and a hotel. On the many well-signposted hiking trails, encouters with wild animals are not uncommon.",
    koppP3:
      "Kopp also belongs to the hamlet of Eigelbach, which is located in a dried-up crater lake. This is very noticable when you drive to Kopp from Gerolstein, via Hinterhausen. Eigelbach is located slightly to the north of Kopp."
  }
};

export default localization;



// WEBPACK FOOTER //
// ./src/localization/thehouse.js